import React from 'react';
import { URLS } from '@wix/da-url';
import { useTranslation, Trans } from 'react-i18next';
import PaywallLayout from '../PaywallLayout';
import CoreStar from '@wix/da-ds/pkg/Icons/CoreStar';
import { getDeviationType } from '../../../../_helpers';
import { DeviationTypes } from '../../../../../types/deviation';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import paywallStyles from '../Paywall.scss';
var textKeyForDeviationType = function (type) {
    if (type === DeviationTypes.LITERATURE) {
        return 'deviationview.paywall.artstage.privilegedFolder.text.literature';
    }
    if (type === DeviationTypes.FILM) {
        return 'deviationview.paywall.artstage.privilegedFolder.text.video';
    }
    return 'deviationview.paywall.artstage.privilegedFolder.text';
};
var PrivilegedFolderPaywall = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    return (React.createElement(PaywallLayout, { deviation: deviation, icon: React.createElement(CoreStar, { className: paywallStyles['premium-folders-icon'] }), title: t('deviationview.paywall.artstage.privilegedFolder.title'), text: 
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: textKeyForDeviationType(getDeviationType(deviation)) },
            "To view, buy",
            React.createElement(BiLink, { className: paywallStyles['folder-preview-button'], href: URLS.CORE_MEMBERSHIP }, "CORE Membership")), width: width, height: height }));
};
PrivilegedFolderPaywall.displayName = 'PrivilegedFolderPaywall';
export default PrivilegedFolderPaywall;
//# sourceMappingURL=PrivilegedFolderPaywall.js.map